
import { Component, OnInit } from '@angular/core';
import { HeadersFacade } from '../../domain/facades/facades';
import { LanguagePipe, LanguageService, WebsiteAttributesService } from 'imakeapp-shared';
import { CartFacade } from 'imakeapp-cart';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BaseHeaderComponenetComponent } from '../../lib/features/base-header-componenet/base-header-componenet.component';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { MessageService } from 'primeng/api';
import { HeaderThemesService } from '../../domain/services/HeaderThemesService.service';







@Component({
  selector: 'ima-header-mobile-theme1',
  templateUrl: './header-mobile-theme1.component.html',
  styleUrls: ['./header-mobile-theme1.component.scss'],
})
export class HeaderMobileTheme1Component  extends BaseHeaderComponenetComponent  implements OnInit
{




  constructor(
    public override router: Router,
    public override store: Store,
    public override fb: FormBuilder,
    public override message_s: MessageService,
    public override header_theme_s: HeaderThemesService,
    public override message: MessageService,
    public override facades:HeadersFacade,
    public override cartFacades:CartFacade,
    public override cookie_s:CookieService,
    public override web_attr_s: WebsiteAttributesService,
    public override lang_s: LanguageService,
    public override lang_p: LanguagePipe,
    public override language_s:LanguageService
  ) {
    super(language_s,cartFacades,facades,store);
    }



}
